var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPillAtom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 124,
    viewBox: "0 0 28 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 65,
    width: 28,
    height: 59,
    rx: 14,
    fill: "#169E50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 22.268 6.26801 16 14 16V16C21.732 16 28 22.268 28 30V88H0V30Z",
    fill: "#FDAA09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0V0C21.732 0 28 6.26801 28 14V40H0V14Z",
    fill: "#FF2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillAtom);
export default __webpack_public_path__ + "static/media/pillAtom.57ba091f8ad6a971f87887366af2271c.svg";
export { ForwardRef as ReactComponent };